import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

export default function CndSelectFilter({ onChange, value, style }) {
  const cndOptions = [
    { label: 'All C&D Types', value: 'allCndTypes' },
    { label: 'Garage C&D only', value: 'GarageC&D' },
    { label: 'Customer C&D only', value: 'CustomerC&D' },
    { label: 'Fixter C&D only', value: 'Fixter' },
  ];

  const renderOptions = (options) =>
    options.map(({ label, value: optionValue }) => (
      <Select.Option key={optionValue} value={optionValue}>
        {label}
      </Select.Option>
    ));

  return (
    <div className={`filter-container ${value ? 'active' : ''}`} style={style}>
      <img src="/assets/icons/filters/car.svg" alt="Country filter" />
      <Select
        key="cndTypes"
        style={{ width: '90%' }}
        dropdownMatchSelectWidth={false}
        onChange={onChange}
        value={value || 'allCndTypes'}
      >
        {renderOptions(cndOptions)}
      </Select>
    </div>
  );
}

CndSelectFilter.propTypes = {
  onChange: PropTypes.any.isRequired,
  value: PropTypes.string,
  style: PropTypes.object,
};

CndSelectFilter.defaultProps = {
  value: null,
  style: null,
};
